/**
 * @property amount - Numerical representation of money
 * @property currency - Will be formatted with non breaking space if provided - EUR 10
 */
export class Money {
  currency?: string;
  amount: number;
  constructor(amount: number, currency?: string) {
    this.amount = amount;
    this.currency = currency;
  }
}
